/**
 * Platform detection for the Capacitor native wrap.
 *
 * Deliberately dependency-free: it reads the global `window.Capacitor` object
 * that the native runtime injects, instead of importing `@capacitor/core`.
 * That means this works on the plain web build (returns 'web' / false) even
 * before Capacitor is installed, and we can gate UI on `isNativeApp()` without
 * a build-time dependency.
 *
 * Used primarily to gate App-Store-sensitive surfaces: per Apple Guideline
 * 3.1.1, the native app must NOT sell digital goods (subscriptions) or link to
 * external purchase for them. So upgrade/subscription CTAs and bounty funding
 * are hidden on native; payouts TO solvers (money flowing to the user) stay.
 */

function cap() {
  return typeof window !== 'undefined' ? window.Capacitor : undefined
}

/** True when running inside the native iOS/Android shell (not the browser). */
export function isNativeApp() {
  const c = cap()
  return !!(c && (typeof c.isNativePlatform === 'function' ? c.isNativePlatform() : c.isNative))
}

/** 'ios' | 'android' | 'web' */
export function getPlatform() {
  const c = cap()
  if (c && typeof c.getPlatform === 'function') return c.getPlatform()
  return 'web'
}

export const isIOS = () => getPlatform() === 'ios'
export const isAndroid = () => getPlatform() === 'android'

/**
 * Whether digital-purchase UI may be shown. False on native (Apple/Play take a
 * 30% cut of in-app digital sales and forbid external-purchase links for them),
 * true on web. Gate subscription upgrades + bounty funding behind this.
 */
export function purchasesAllowed() {
  return !isNativeApp()
}
